"use client";

import React, { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function TheLionheartedPhilosophy() {
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const sectionRef = useRef<HTMLElement>(null);
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!sectionRef.current) return;
      const {
        clientX,
        clientY
      } = e;
      const {
        innerWidth,
        innerHeight
      } = window;
      const x = clientX / innerWidth * 2 - 1;
      const y = clientY / innerHeight * 2 - 1;
      setMousePos({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section data-section-id="44068" id="the-rpg-studios-philosophy" ref={sectionRef} className="relative w-full py-24 md:py-32 overflow-hidden bg-card text-foreground">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-0 opacity-[0.04] transition-transform duration-100 ease-out will-change-transform" style={{
      transform: `translate(${mousePos.x * -20}px, ${mousePos.y * -20}px)`
    }}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/lion_leaf_watermark.png" alt="Lionhearted Watermark" className="w-[120%] max-w-[900px] h-auto object-contain" />
      </div>

      {}
      <div className="hidden lg:flex fixed-like absolute left-8 top-1/2 -translate-y-1/2 z-10 h-full flex-col justify-center">
        <span className="block -rotate-180 text-xs font-mono font-bold tracking-[0.4em] text-primary [writing-mode:vertical-rl]">
          DIGITAL CONNECTIVITY
        </span>
      </div>
      <div className="hidden lg:flex fixed-like absolute right-8 top-1/2 -translate-y-1/2 z-10 h-full flex-col justify-center">
        <span className="block rotate-0 text-xs font-mono font-bold tracking-[0.4em] text-primary [writing-mode:vertical-rl]">
          LONG-TERM PARTNERSHIP
        </span>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-6">
        <div ref={textRef} className={`max-w-[800px] mx-auto flex flex-col gap-10 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-center text-foreground tracking-tight mb-4">
            Building Relationships, Not Just Businesses
          </h2>

          <div className="space-y-8 text-lg md:text-[20px] leading-relaxed font-sans text-muted-foreground text-center">
            <p>
              At RPG-Studios, we believe that true digital growth requires more than just code and graphics—it demands a foundation of trust and shared vision.
            </p>
            <p>
              Our philosophy centers on the idea that every website, SEO strategy, and social campaign is a bridge between your brand and your community. We integrate the precision of modern technology with the warmth of human partnership to create digital ecosystems that thrive.
            </p>
            <p>
              From our home in Quitman, GA, we empower businesses to navigate the digital landscape with confidence. We don&apos;t just deliver services; we cultivate long-term success through regenerative design and transparent communication.
            </p>
          </div>

          <div className="flex justify-center pt-8">
            <Button asChild variant="outline" className="border-primary/40 hover:bg-primary/10 text-primary font-sans font-semibold tracking-wider px-8 py-6 rounded-md transition-colors">
              <Link to="/ServicesPage">
                Explore Our Services <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}